import React from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import * as Icons from "lucide-react";
import { Link } from "react-router-dom";
import { NotificationType } from "common/data/constants";

const NotificationModal = ({ isOpen, toggle, notificationList = [] }) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle} size="xl">
      <ModalHeader toggle={toggle}>All Notifications</ModalHeader>

      <ModalBody style={{ maxHeight: "70vh", overflowY: "auto" }}>
        {notificationList.length === 0 ? (
          <p className="text-center text-muted">No notifications found</p>
        ) : (
          notificationList.map((item, index) => {
            const typeData = NotificationType.find(
              t => t.value === item.not_type
            );
            const IconComponent =
              Icons[typeData?.icon] || Icons["Bell"];

            return (
              <Link
                to="#"
                key={index}
                className="text-reset notification-item"
              >
                <div className="d-flex py-2 border-bottom">

                  <div className="avatar-xs me-3">
                    <span className="avatar-title bg-primary rounded-circle font-size-16">
                      <IconComponent size={16} />
                    </span>
                  </div>

                  <div className="flex-grow-1">
                    <h6 className="mt-0 mb-1">
                      {typeData?.label || "Notification"}
                    </h6>

                    <div className="font-size-12 text-muted">

                      {item.subject && (
                        <p className="mb-1">
                          <strong>{item.subject}</strong>
                        </p>
                      )}

                      <p
                        className="mb-0"
                        dangerouslySetInnerHTML={{
                          __html: item.description,
                        }}
                      />
                    </div>
                  </div>
                </div>
              </Link>
            );
          })
        )}
      </ModalBody>
    </Modal>
  );
};

export default NotificationModal;
